import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { CitationStyle } from './citation.model';

@Injectable({
  providedIn: 'root'
})
export class CitationService {
  private readonly http = inject(HttpClient);

  getCitationStyles(recordId: string) {
    const url = `${environment.apiUrl}/records/${recordId}/cite`;

    return this.http.get<CitationStyle[]>(url);
  }
}
